import { z } from 'zod';

export const logIdParam = z.object({ id: z.string().min(1) });
export type LogIdParam = z.infer<typeof logIdParam>;

export const latestLogQuery = z.object({
  patientId: z.uuid(),
});
export type LatestLogQuery = z.infer<typeof latestLogQuery>;

export const createLogBody = z.object({
  createdAt: z.coerce.date().optional(),
  codeId: z.uuid(),
  patientId: z.uuid(),
  metadata: z.record(z.string(), z.string()).optional().default({}),
});
export type CreateLogBody = z.infer<typeof createLogBody>;
